// extracted by mini-css-extract-plugin
module.exports = {"key":"key--2pFMF","text":"text--3l9Y6","wrapper":"wrapper--3BkM_"};